const zoftokenApiURL = "https://zaas.zoftoken.com/token";
const zaasApiURL = "https://zaas.zoftoken.com/api";

// ZaaS API functions

export function registerSubscription(id, email, password) {
    return new Promise(async (resolve, reject) => {

        try {
            let serverResponse = await fetch(`${zaasApiURL}/subscription`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: id,
                    email: email,
                    password: password
                })
            });

            if (serverResponse.status == 200) {
                resolve();
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}

export function getSubscription(email, password) {
    return new Promise(async (resolve, reject) => {

        try {
            let serverResponse = await fetch(`${zaasApiURL}/subscription?email=${encodeURIComponent(email)}&password=${encodeURIComponent(password)}`);

            if (serverResponse.status == 200) {

                let subscription = await serverResponse.json();
                resolve(subscription);
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}

export function deleteSubscription(id, code) {
    return new Promise(async (resolve, reject) => {

        try {
            let serverResponse = await fetch(`${zaasApiURL}/subscription`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: id,
                    code: code
                })
            });

            if (serverResponse.status == 200) {
                resolve();
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}

export function requestPasswordReset(email) {
    return new Promise(async (resolve, reject) => {

        try {
            let serverResponse = await fetch(`${zaasApiURL}/credentials/resetpassword`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email
                })
            });

            if (serverResponse.status == 200) {
                resolve();
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}


export function requestPasswordChange(id, code, currentPassword, newPassword) {
    return new Promise(async (resolve, reject) => {

        try {
            let serverResponse = await fetch(`${zaasApiURL}/credentials`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: id,
                    code: code,
                    currentPassword: currentPassword,
                    newPassword: newPassword
                })
            });

            if (serverResponse.status == 200) {
                resolve();
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}

export function checkAdminToken(id, code) {
    return new Promise(async (resolve, reject) => {

        try {
            let serverResponse = await fetch(`${zaasApiURL}/credentials/admintoken?id=${encodeURIComponent(id)}&code=${encodeURIComponent(code)}`);

            if (serverResponse.status == 200) {
                resolve(true);
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}

export function requestTokenReset(id, code, currentPassword) {
    return new Promise(async (resolve, reject) => {

        try {
            let serverResponse = await fetch(`${zaasApiURL}/credentials`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: id,
                    code: code,
                    currentPassword: currentPassword,
                    resetZT: true
                })
            });

            if (serverResponse.status == 490) {
                resolve();
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}


export function getUsers(id, code) {
    return new Promise(async (resolve, reject) => {

        try {
            let serverResponse = await fetch(`${zaasApiURL}/info/users?id=${id}&code=${encodeURIComponent(code)}`);

            if (serverResponse.status == 200) {

                let userData = await serverResponse.json();
                resolve(userData);
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}

export function addService(id, code, service, window, duress) {
    return new Promise(async (resolve, reject) => {

        try {
            let serverResponse = await fetch(`${zaasApiURL}/service`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: id,
                    code: code,
                    service: service,
                    window: window,
                    duress: duress
                })
            });

            if (serverResponse.status == 200) {

                let newServiceContent = await serverResponse.json();
                resolve(newServiceContent);
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}


export function changeService(id, code, service, window, hook, details) {
    return new Promise(async (resolve, reject) => {

        try {
            let serverResponse = await fetch(`${zaasApiURL}/service`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: id,
                    code: code,
                    service: service,
                    window: window,
                    hook: hook,
                    details: details
                })
            });

            if (serverResponse.status == 200) {
                resolve();
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}

export function deleteService(id, code, service) {
    return new Promise(async (resolve, reject) => {
        try {
            let serverResponse = await fetch(`${zaasApiURL}/service`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: id,
                    service: service,
                    code: code
                })
            });

            if (serverResponse.status == 200) {
                resolve();
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}


export function hookTest(id, code, hook) {
    return new Promise(async (resolve, reject) => {
        try {
            let serverResponse = await fetch(`${zaasApiURL}/info/testhook`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: id,
                    hook: hook,
                    code: code
                })
            });

            if (serverResponse.status == 200) {

                let testResults = await serverResponse.json();
                resolve(testResults);
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}


// ZofToken API functions

export function enrollUser(id, service, authKey, reset) {
    return new Promise(async (resolve, reject) => {

        try {
            let serverResponse = await fetch(`${zoftokenApiURL}/enrollment`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: id,
                    service: service,
                    authKey: authKey,
                    codeSize: 32,
                    forceReset: reset
                })
            });

            if (serverResponse.status == 200) {

                let enrollData = await serverResponse.json();
                resolve(enrollData);
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}

export function statusChange(id, service, authKey, status) {
    return new Promise(async (resolve, reject) => {

        try {
            let serverResponse = await fetch(`${zoftokenApiURL}/statusadmin`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: id,
                    service: service,
                    authKey: authKey,
                    status: status
                })
            });

            if (serverResponse.status == 200) {
                resolve();
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}

export function getUserStatus(id, service, authKey) {
    return new Promise(async (resolve, reject) => {

        try {
            let serverResponse = await fetch(`${zoftokenApiURL}/status?id=${id}&service=${service}&authKey=${authKey}`);

            if (serverResponse.status == 200) {
                let statusBody = await serverResponse.json();
                resolve(statusBody.status);
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}

export function deleteUser(id, service, authKey) {
    return new Promise(async (resolve, reject) => {
        try {
            let serverResponse = await fetch(`${zoftokenApiURL}/removal`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: id,
                    service: service,
                    authKey: authKey
                })
            });

            if (serverResponse.status == 200) {
                resolve();
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}

export function getOfflineChallenge(id, service, authKey, codeSize) {
    return new Promise(async (resolve, reject) => {

        try {
            let serverResponse = await fetch(`${zoftokenApiURL}/offlinechallenge?id=${id}&service=${service}&authKey=${authKey}&codeSize=${codeSize}`);

            if (serverResponse.status == 200) {
                let challengeBody = await serverResponse.json();
                resolve(challengeBody.offlineChallenge);
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}

export function sendOfflineResponse(id, service, authKey, response) {
    return new Promise(async (resolve, reject) => {
        try {
            let serverResponse = await fetch(`${zoftokenApiURL}/offlineresponse`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: id,
                    service: service,
                    authKey: authKey,
                    response: response
                })
            });

            if (serverResponse.status == 200) {
                let statusBody = await serverResponse.json();
                resolve(statusBody.status);
            }
            else {
                reject(serverResponse.status);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}